import { render, staticRenderFns } from "./Tag2.vue?vue&type=template&id=54d779e3&scoped=true"
import script from "./Tag2.vue?vue&type=script&lang=js"
export * from "./Tag2.vue?vue&type=script&lang=js"
import style0 from "./Tag2.vue?vue&type=style&index=0&id=54d779e3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d779e3",
  null
  
)

export default component.exports